import { ensureDefined, SMap } from '@avantia/client-and-server-utilities';
import { lodash } from '@avantia/lodash';
import { HpError } from '@avantia/logging-and-errors';
import { HpMetaData } from '../../../tools/clientAndServerUtilities';
import { NavigationTabAllSectionsControl } from './navigationTabAllSectionsControl';
import { HpGetNavigationTabControlFunction } from './navigationTabControlTypes';

type NavControl = HpGetNavigationTabControlFunction<HpMetaData>;

const defaultControl: NavControl = () => NavigationTabAllSectionsControl;
const navTabControls: SMap<NavControl> = {};

export function registerNavigationTabControls<MetaDataT extends HpMetaData>(
  controlFuncs: SMap<HpGetNavigationTabControlFunction<MetaDataT>>
): void {
  lodash.keys(controlFuncs).forEach((controlType) => {
    registerNavigationTabControl(controlType, controlFuncs[controlType]);
  });
}

function registerNavigationTabControl<MetaDataT extends HpMetaData>(
  controlType: string,
  controlFunc: HpGetNavigationTabControlFunction<MetaDataT>
): void {
  if (controlType.startsWith('get')) {
    controlType = controlType.substring(3);
  }

  const expectedSuffix = 'NavigationTabControl';
  if (!controlType.endsWith(expectedSuffix)) {
    throw new HpError(
      `A heading registered via registerHeadingControl(...) must end with the suffix '${expectedSuffix}'. Found '${controlType}' instead.`
    );
  } else {
    controlType = controlType.substring(0, controlType.length - expectedSuffix.length);
  }

  navTabControls[controlType] = ensureDefined(controlFunc as NavControl, `navTabControls['${controlType}']`);
}

export function getNavigationTabControl<MetaDataT extends HpMetaData>(
  controlType: string | undefined
): HpGetNavigationTabControlFunction<MetaDataT> {
  const control: NavControl = controlType
    ? ensureDefined(navTabControls[controlType], `navTabControls['${controlType}']`)
    : defaultControl;
  return control as HpGetNavigationTabControlFunction<MetaDataT>;
}
